import { AxiosError } from 'axios';
import LayoutContext from 'components/Layout/LayoutContext';
import translation from 'locales/translation';
import {
  Col,
  Collapse,
  Modal,
  ModalSizes,
  Row,
  ThreeDotsLoader,
  ToastTypes,
} from 'plataforma-fundacao-componentes';
import { ModalProps } from 'plataforma-fundacao-componentes/dist/components/modal/Modal';
import { useContext, useEffect } from 'react';
import { useGetEvidence } from '../../../services/editVotes';

type EvidenceType = {
  idConvocado: number;
  idEvento: number;
} & ModalProps;

export const Evidence = (props: EvidenceType) => {
  const { data, isLoading, isError, error } = useGetEvidence(
    props.idConvocado,
    props.idEvento
  );

  const { showToast } = useContext(LayoutContext);

  useEffect(() => {
    if (isError) {
      showToast({
        pauseOnFocusLoss: true,
        theme: ToastTypes.Error,
        showStatusBar: true,
        timeout: 4000,
        label:
          translation.Toasts.Errors.Keys[
            `${
              (error as AxiosError<Error>).response?.data.message ||
              (error as AxiosError<Error>).response?.data ||
              (error as AxiosError<Error>).message
            }` as keyof typeof translation.Toasts.Errors.Keys
          ] ?? translation.Toasts.Errors.defaultAlternative,
      });
    }
  }, [error, isError, showToast]);

  return (
    <Modal
      title={'Evidência'}
      preventEscExit={props.preventEscExit || false}
      preventMaskExit={props.preventMaskExit || false}
      modalKey={props.modalKey}
      mobileOn={props.mobileOn}
      onClose={props.onClose}
      size={ModalSizes.Large}
    >
      <Row>
        <Collapse opened={!isLoading} animateOpacity>
          <Col centralized>
            {data ? (
              <img
                src={URL.createObjectURL(data)}
                alt={'Evidência'}
                style={{ overflow: 'hidden', borderRadius: '10px' }}
              />
            ) : (
              <p>Erro ao carregar a evidência.</p>
            )}
          </Col>
        </Collapse>
        <Collapse opened={isLoading} animateOpacity>
          <Col centralized>
            <ThreeDotsLoader />
          </Col>
        </Collapse>
      </Row>
    </Modal>
  );
};
